export class SessionCacheUtil {
    static getSessionStorageObject(name: string) {
        let localObject = sessionStorage.getItem(name);
        if (localObject && localObject !== "undefined") {
            return JSON.parse(sessionStorage.getItem(name)!);
        } else {
            return null;
        }
    }

    static putSessionStorageObject(name: string, value: any) {
        sessionStorage.setItem(name, JSON.stringify(value));
    }

    static removeSessionStorageObject(name: string) {
        sessionStorage.removeItem(name);
    }

    static getLocalStorageObject(name: string) {
        return JSON.parse(localStorage.getItem(name)!);
    }

    static putLocalStorageObject(name: string, value: any) {
        localStorage.setItem(name, JSON.stringify(value));
    }

    static removeLocalStorageObject(name: string) {
        localStorage.removeItem(name);
    }

    static clearSessionStorageExcept(...attrNames: string[]) {
        for (let sessionStorageKey in sessionStorage) {
            if (attrNames.find((key) => key == sessionStorageKey) == undefined) {
                sessionStorage.removeItem(sessionStorageKey);
            }
        }
    }

    static clearSessionStorage(){
      sessionStorage.clear();
    }
}
